import $ from 'jquery';

import './mobileMenu';

import './plugins/formValidation/formValidation';
import './plugins/formValidation/formValidation.css';
import {initRecaptcha} from "./plugins/recaptcha";

((
    ($) => {
        $(document).ready(function () {
            const header = document.getElementById("header");
            const sticky = header.offsetTop;

            function stickyMenu() {
                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                } else {
                    header.classList.remove("sticky");
                }
            }

            function mainMenu() {
                if ($(window).innerWidth() > 768) {
                    $('.main-menu-list li').hover(function () {
                        let counter = 100;
                        const children = $(this).find('>ul>li');
                        children.each(function (index, child) {
                            $(child).css('transition-delay', counter + 'ms');
                            counter = counter + 100;
                        });
                    });
                }
            }

            $('[data-popup-toggle]').click(function (e) {
                e.preventDefault();
                if (!($(`#${$(this).data('popup-toggle')}`).hasClass('open'))) {
                    $(`#${$(this).data('popup-toggle')}`).addClass('open');
                    $('body').css('overflow', 'hidden');
                    const me = this;
                    initRecaptcha()
                        .then(() => {
                            $(me).parent().find('.recaptcha').addClass('open');
                        }).catch((err) => {
                    })
                } else {
                    $(`#${$(this).data('popup-toggle')}`).removeClass('open');
                    $('body').removeAttr('style');
                }
            });

            let notAdded = true;
            const mainFooter = $('#col-none-575');
            const col = $('<div class="col-12 added-col"></div>');
            const mainRow = $('#footer-row');
            const logo = mainFooter.find('#blue-logo').clone(true);
            col.append(logo);

            function footer() {
                if ($(window).innerWidth() < 576 && notAdded) {
                    $('.col-none-575').remove();
                    mainRow.append(col);
                    notAdded = false;
                } else if ($(window).innerWidth() >= 576 && !notAdded) {
                    mainRow.find('.added-col').remove();
                    mainRow.prepend(mainFooter);
                    notAdded = true;
                }
            }

            const UpBtn = $('#upBtn');

            function toTop() {
                if ($(window).scrollTop() > 300) {
                    UpBtn.addClass('show');
                } else {
                    UpBtn.removeClass('show');
                }
            }

            UpBtn.on('click', function (e) {
                e.preventDefault();
                $('html, body').stop().animate({scrollTop: 0}, 300);
            });

            let _forms = $('.validate-form');
            if (_forms.length) {
                let _headerHeight = 140;
                let _options = {
                    checkRequired: true,
                    scrollToFirstError: true,
                    scrollMargin: _headerHeight,
                    showErrorGeneralMsg: false,
                    requiredMsg: 'This Field is required!',
                    emailValidationMsg: 'Invalid email address!',
                    beforeAjaxCallBack: function (_form) {
                    }
                };
                _forms.each(function () {
                    if ($(this).hasClass('js-dont-scroll')) {
                        _options.scrollToFirstError = false;
                    }
                    if ($(this).hasClass('js-dont-empty')) {
                        _options.emptyFieldsOnSuccess = false;
                    }
                    if ($(this).attr('id') === 'js-donation-form') {
                        _options.emptyFieldsOnSuccess = false;
                        _options.beforeSuccessStartsCallBack = function (_form, _response) {
                            $('body').append(_response.html);
                        };
                    }
                    $(this).validateForm(_options);
                });
            }
            const _loadFormCaptcha = function (_form) {
                let _captcha = _form.find('.g-recaptcha');
                if (_captcha.length && typeof grecaptcha !== 'undefined') {
                    if (typeof _captcha.attr('data-id') === 'undefined') {
                        setTimeout(function () {
                            let widgetId = grecaptcha.render(_captcha[0], {
                                'sitekey': window.application.services.gcaptcha.site_key
                            });
                            _captcha.attr('data-id', widgetId);
                        }, 1000);
                    }
                }
            };

            $('form').each((_index, _form) => {
                _form = $(_form);
                _form.find('input, select, textarea').on('focus', function () {
                    if (!_form.is(':visible')) {
                        return;
                    }
                    initRecaptcha()
                        .then(() => {
                            _loadFormCaptcha(_form);
                        }).catch((err) => {
                    });
                });
                _form.find('button[type=submit]').on('click', function () {
                    if (!_form.is(':visible')) {
                        return;
                    }
                    initRecaptcha()
                        .then(() => {
                            _loadFormCaptcha(_form);
                        }).catch((err) => {
                    });
                });
            });

            mainMenu();
            stickyMenu();
            footer();
            toTop();

            $(window).on('scroll', function () {
                stickyMenu();
                toTop();
            });

            $(window).on('resize', function () {
                footer();
            });
        });
    }
)
(jQuery));